import { Reveal, Kicker } from "./Reveal";

const QUESTIONS = [
  "What was the system authorised to do?",
  "Which policy governed the decision?",
  "Why was the action permitted?",
  "Who approved the policy?",
  "Can the action be stopped or reversed?",
  "What commercial outcome followed?",
];

export default function Problem() {
  return (
    <section id="problem" className="border-b border-white/10" data-testid="problem-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <Kicker index="01" label="The problem" />
          <h2 className="max-w-5xl font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl" data-testid="problem-heading">
            AI can make commercial decisions faster than organisations can{" "}
            <span className="text-zinc-600">safely govern them.</span>
          </h2>
          <div className="mt-10 max-w-2xl space-y-4 font-mono text-sm leading-relaxed text-zinc-400">
            <p>Pricing signals update continuously.</p>
            <p>Models can increasingly recommend commercial actions in real time.</p>
            <p className="text-zinc-300">
              But enterprises cannot delegate consequential pricing decisions unless they can answer:
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {QUESTIONS.map((q, i) => (
            <Reveal key={q} delay={i * 0.07} className="group bg-[#050505] p-8 transition-colors duration-500 hover:bg-[#0F0F11]">
              <div className="font-mono text-xs text-[#00FF41]">Q{i + 1}</div>
              <p className="mt-5 font-mono text-sm leading-relaxed text-zinc-300" data-testid={`problem-question-${i + 1}`}>{q}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-20 max-w-5xl font-display text-3xl font-extrabold leading-tight tracking-tighter sm:text-4xl" data-testid="problem-closing">
            Autonomy without governance is a demo.{" "}
            <span className="text-[#00FF41]">Governance is the product.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
